module.exports = __webpack_public_path__ + "static/ecommerce3-c55189a7ab76beb11a9e2b5dada79a0b.jpg";